/* tslint:disable */
/* eslint-disable */
/**
 * BuLLy documentation
 * BuLLy Server
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: info@redcare-pharmacy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * This will hold the value of the condition Might only count offers affected by the promotion / from this seller This field is forward-compatible; clients must handle unknown values.
 */
export const OfferConditionTypeEnumV2 = {
    MinimumOrderValue: 'minimumOrderValue',
    MinimumQuantity: 'minimumQuantity',
    MinimumSameItemQuantity: 'minimumSameItemQuantity'
};
